import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import MapCustomizer from "@/components/MapCustomizer";

const Studio = () => {
  return (
    <div>
      {/* Studio Header */}
      <section className="py-10 md:py-12 px-6" style={{ backgroundColor: "var(--brand-bg)" }}>
        <div className="max-w-[72rem] mx-auto">
          {/* Breadcrumb */}
          <nav aria-label="Breadcrumb" className="mb-6">
            <ol className="flex items-center gap-2 text-[0.8125rem]" style={{ fontFamily: "var(--font-body)" }}>
              <li>
                <Link to="/" className="transition-colors" style={{ color: "var(--brand-muted)" }}>Home</Link>
              </li>
              <li aria-hidden="true" style={{ color: "var(--brand-light)" }}>
                <ChevronRight className="w-3.5 h-3.5" />
              </li>
              <li>
                <span aria-current="page" className="font-medium" style={{ color: "var(--brand-text)" }}>3D Custom Map Art</span>
              </li>
            </ol>
          </nav>

          {/* Header content */}
          <div className="text-center max-w-[40rem] mx-auto">
            <p className="text-xs tracking-[0.2em] uppercase mb-3 font-medium" style={{ color: "var(--sage-400)", fontFamily: "var(--font-body)" }}>
              Design Studio
            </p>
            <h1 className="mb-3" style={{ fontFamily: "var(--font-heading)", fontSize: "clamp(1.75rem, 4vw, 2.5rem)", color: "var(--brand-text)", lineHeight: 1.15 }}>
              Create Your Masterpiece
            </h1>
            <p className="max-w-lg mx-auto" style={{ fontFamily: "var(--font-body)", color: "var(--brand-muted)", fontSize: "clamp(0.9375rem, 1.2vw, 1.0625rem)", lineHeight: 1.6, fontWeight: 300 }}>
              Search any place in the world and transform it into a one-of-a-kind 3D map art piece.
            </p>
          </div>
        </div>
      </section>

      {/* MapCustomizer */}
      <div className="px-6 pb-12">
        <MapCustomizer />
      </div>
    </div>
  );
};

export default Studio;
